import { Action } from '@ngrx/store';

export class InitializerAction implements Action {

    public static settingsLoaded =  '[Initializer] settings_loadded';
    public static noPreviousUserFound =  '[Initializer] no_previous_user_found';
    public static resetUserRelatedData = '[Initializer] reset_user_related_data';

    public static getSessionID = '[Initializer] get_session_id';
    public static getSessionIDError = '[Initializer] get_session_id_error';
    public static getSessionIDSuccess = '[Initializer] get_session_id_success';

    public static connectToRealTime = '[Initializer] connect_to_realtime';
    public static connectToRealTimeError = '[Initializer] connect_to_realtime_error';
    public static connectToRealTimeSuccess = '[Initializer] connect_to_realtime_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}
}
